import "../styles/retureButton.scss";
export default {
  name: "RetureButton",
  render(h) {
    const { $scopedSlots } = this;
    return h(
      "button",
      {
        class: ["reture-button"],
        on: {
          click: () => this.$emit("onClick"),
        },
      },
      $scopedSlots.default.call(this)
    );
  },
};
